/* eslint-disable react/no-unused-state */
import React, {
  Component,
  Children,
  isValidElement,
  cloneElement
} from "react";
import PropTypes from "prop-types";
import { gatherClasses } from "../../lib/utils";
import { OrionContext } from "../orionContext/orionContext";
import {
  DISPLAY_NAME_PAGE,
  DISPLAY_NAME_SIDEBAR,
  DISPLAY_NAME_MAIN,
  DISPLAY_NAME_FOOTER,
  DISPLAY_NAME_ALERT
} from "./constants";
import PageAlert from "./pageAlert";
import PageMain from "./pageMain";
import PageHeader from "./pageHeader";
import PageFooter from "./pageFooter";
import PageTitle from "./pageTitle";
import PageTitleText from "./pageTitleText";
import PageActions from "./pageActions";
import PageBody from "./pageBody";
import PageTabs from "./pageTabs";
import PageProvider from "./pageContext";
import "./style.scss";
import "./msp-provider.scss";

class OrionPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabPresent: false,
      setTabPresence: this.setTabPresence,
      showAlert: true
    };
  }

  hideAlert = () => {
    this.setState({ showAlert: false });
  };

  setTabPresence = tabPresent => {
    this.setState({
      tabPresent
    });
  };

  componentDidMount() {
    document.body.classList.add("oui-overflow-hidden");
  }

  componentWillUnmount() {
    document.body.classList.remove("oui-overflow-hidden");
  }

  resolveComponents() {
    let sidebar = null;
    let main = null;
    let footer = null;
    let alert = null;
    const remaining = [];
    const { children } = this.props;

    Children.forEach(children, child => {
      if (isValidElement(child)) {
        if (child.type.displayName === DISPLAY_NAME_SIDEBAR) {
          sidebar = child;
        } else if (child.type.displayName === DISPLAY_NAME_MAIN) {
          main = child;
        } else if (child.type.displayName === DISPLAY_NAME_FOOTER) {
          footer = child;
        } else if (child.type.displayName === DISPLAY_NAME_ALERT) {
          alert = cloneElement(child, {
            className: gatherClasses(
              null,
              child.props.className,
              "oui-mb-0 oui-rounded-0"
            ),
            onClose: child.props.onClose || this.hideAlert
          });
        } else {
          remaining.push(child);
        }
      } else {
        remaining.push(child);
      }
    });

    return { alert, sidebar, main, footer, remaining };
  }

  render() {
    const { showAlert } = this.state;
    const { honourNavHeight, leaveFooterSpace, dataTestId } = this.props;
    const { alert, sidebar, main, footer, remaining } =
      this.resolveComponents();
    const { dellDoubleHeader } = this.context || {};

    return (
      <PageProvider value={this.state}>
        <div
          data-testid={dataTestId}
          className={gatherClasses(
            this.props,
            "oui-page",
            dellDoubleHeader && "oui-double-header-support",
            honourNavHeight ? "oui-honour-nav-height" : "",
            footer !== null || leaveFooterSpace ? "oui-page-with-footer" : "",
            alert !== null && showAlert ? "oui-page-with-alert" : ""
          )}
        >
          {showAlert ? alert : null}
          <div className="oui-d-flex">
            {sidebar
              ? React.cloneElement(sidebar, {
                  honourGlobalFooter: footer !== null || leaveFooterSpace,
                  honourPageAlert: alert !== null && showAlert
                })
              : null}
            {main}
            {remaining}
          </div>
        </div>
        {footer}
      </PageProvider>
    );
  }
}

OrionPage.contextType = OrionContext;

OrionPage.defaultProps = {
  honourNavHeight: true,
  leaveFooterSpace: false,
  dataTestId: "orion-page"
};

OrionPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  honourNavHeight: PropTypes.bool,
  leaveFooterSpace: PropTypes.bool,
  dataTestId: PropTypes.string
};

OrionPage.displayName = DISPLAY_NAME_PAGE;
OrionPage.Alert = PageAlert;
OrionPage.Main = PageMain;
OrionPage.Header = PageHeader;
OrionPage.Footer = PageFooter;
OrionPage.Title = PageTitle;
OrionPage.TitleText = PageTitleText;
OrionPage.Actions = PageActions;
OrionPage.Body = PageBody;
OrionPage.Tabs = PageTabs;

export default OrionPage;
